import { EVENTS, PAGE_ERROR } from 'common/domain/constants';
import { STATES } from 'common/domain/states';

class LoansRoutingController {
  constructor(
    loansService,
    $scope,
    $state,
    $translate,
    $rootScope,
    $window,
    $stateParams,
    $log,
    LoansUserDataService,
    loansMenuService,
    toastr,
    LoansNeedALoanService,
    metricsService,
    cookieService
  ) {
    'ngInject';
    this.scope = $scope;
    this.state = $state;
    this.translate = $translate;
    this.rootScope = $rootScope;
    this.stateParams = $stateParams;
    this.log = $log;

    this.loansUserDataService = LoansUserDataService;
    this.loansService = loansService;
    this.loansMenuService = loansMenuService;
    this.toastr = toastr;
    this.loansNeedALoanService = LoansNeedALoanService;
    this.metricsService = metricsService;
    this.cookieService = cookieService;

    this.isMobileApp = $window.innerWidth < 1024;

    this.isLoaded = false;
    this.hasLoansAccess = true;
  }

  $onInit() {
    if (this.isModuleClosed()) {
      return;
    }

    this.loansService.loadEmployeeProfileInfoAndData();
    this._checkServiceClosed();

    this.metricsService.init();

    this.rootScope.$on(EVENTS.WITHOUT_LOANS_ACCESS, () => {
      this.hasLoansAccess = false;
    });

    this.scope.$watch(
      () => this.loansService.loaded,
      newValue => {
        if (newValue) {
          this.log.info('loansService loaded');
          this.isLoaded = true;
          this.employee = this.loansUserDataService.getEmployee();
          this._initLinks();
          this.rootScope.$on('$locationChangeSuccess', () =>
            this._checkServiceClosed()
          );
        }
      }
    );
  }

  _checkServiceClosed() {
    if (!this.moduleClosed.serviceClosed) {
      return;
    }
    this._translateTextToToast().then(() => {
      this._showOrHideToastr();
    });
  }

  getCssMenu() {
    return {
      'no-border': this._linkHasNotMenuBorder()
    };
  }

  _initLinks() {
    this.links = this.loansMenuService.getLinks();

    this.links.forEach(link => {
      link.onClick = () => {
        this.loansNeedALoanService.clearAllDataSimulation();
      };
    });
  }

  _showOrHideToastr() {
    const isPortalSenior = this.cookieService.get('isPortalSenior');
    
    if (isPortalSenior === 'true') {
      return;
    }
    const toastElement = angular.element('.toast-container');
    let currentName = this.state.current.name;
    const isWageAdvance = STATES.LOANS.WAGE_ADVANCE === currentName;
    let isHiddenToastr = toastElement.is(':visible') ? false : true;

    if (!isWageAdvance && isHiddenToastr) {
      this.toastr.error(this.textToast, this.titleToast);
      toastElement.fadeIn();
    }

    if (isWageAdvance) {
      toastElement.fadeOut();
    }
  }

  _translateTextToToast() {
    this.translate('GLOBALS.WARNING_TITLE').then(translation => {
      this.titleToast = translation.$$unwrapTrustedValue();
    });
    return this.translate('GLOBALS.READ_ONLY_WAGE_IN_PROCESS').then(
      translation => {
        this.textToast = translation.$$unwrapTrustedValue();
      }
    );
  }

  _linkHasNotMenuBorder() {
    let currentLinkHasMenuBorder = link => {
      return link.target === this.state.current.name && link.hasMenuBorder;
    };

    let stateIsDetail = this.state.current.name === STATES.LOANS.DETAIL;
    let stateIsSignUp = this.state.current.name === STATES.LOANS.SIGN_UP;

    return (
      (this.links && this.links.some(currentLinkHasMenuBorder)) ||
      stateIsDetail ||
      stateIsSignUp
    );
  }

  isModuleClosed() {
    const hasToGoWageAdvance = this.stateParams.goWageAdvance;

    if (hasToGoWageAdvance) {
      this.goToWageAdvanceWithoutLoansAccess();
      return;
    }

    const isLoansAndWageAdvanceClosedWithMessage =
      this.moduleClosed.isLoansClosed &&
      this.moduleClosed.loansClosedMessage &&
      this.isWageAdvanceClosed;
    const isLoansAndWageAdvanceClosedWithoutMessage =
      this.moduleClosed.isLoansClosed && this.isWageAdvanceClosed;
    const isLoansClosedAndWageOpen =
      this.moduleClosed.isLoansClosed && !this.isWageAdvanceClosed;

    if (isLoansAndWageAdvanceClosedWithMessage) {
      this.goToErrorAndShowHRMessage();
      return true;
    }

    if (isLoansAndWageAdvanceClosedWithoutMessage) {
      this.goToErrorWithoutMessage();
      return true;
    }

    if (isLoansClosedAndWageOpen) {
      this.goToErrorWithLinkToWage();
    }
    return false;
  }

  goToErrorAndShowHRMessage() {
    this.state.go(STATES.ERROR, {
      stateName: PAGE_ERROR.CLOSED,
      errorMessage: this.moduleClosed.loansClosedMessage
    });
  }

  goToErrorWithoutMessage() {
    this.state.go(STATES.ERROR, { stateName: PAGE_ERROR.CLOSED });
  }

  goToErrorWithLinkToWage() {
    this.state.go(STATES.ERROR, {
      stateName: PAGE_ERROR.CLOSED,
      stateRedirection: this.moduleClosed.isWageAdvanceClosed
    });
  }

  goToWageAdvanceWithoutLoansAccess() {
    if (this.loansUserDataService.getSenior()) {
      this.state.go(STATES.ERROR, {
        stateName: PAGE_ERROR.LOANS_CLOSED_TO_USER_WITHOUT_CREDITWORTHINESS
      });
    } else {
      this.state.go(STATES.LOANS.WAGE_ADVANCE, {
        stateAccess: EVENTS.WITHOUT_LOANS_ACCESS
      });
    }
  }

  showMenu() {
    return !this.isMobileApp && this.hasLoansAccess;
  }

  showMobileLinks() {
    return this.isMobileApp && this.hasLoansAccess;
  }

  showMenuMobile() {
    return this.isMobileApp && this.isLoaded && this.links;
  }
}

export default LoansRoutingController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRouting/loansRouting.controller.js